import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import Home from '@/pages/Home'
import Mine from '@/pages/Mine'
import Success from '@/pages/Success'

import Orders from '@/pages/Orders'

import Bind from '@/pages/Bind'
import Passport from '@/pages/Passport'
import Qrcode from '@/pages/Qrcode'

import InfArticleModel from '@/pages/inf/article/Model'

import Wallet from '@/pages/Wallet'
import Wishlist from '@/pages/Wishlist'
import Verifies from '@/pages/Verifies'
import Request from '@/pages/Request'

import CusUserModify from '@/pages/cus/user/Modify'
import SalOrderModel from '@/pages/sal/order/Model'
import SalProductModel from '@/pages/sal/product/Model'
import SalPledgeModel from '@/pages/sal/pledge/Model'
import SalPledgeModels from '@/pages/sal/pledge/Models'
import WeiUserMobile from '@/pages/wei/user/Mobile'
import WeiUserModify from '@/pages/wei/user/Modify'

import Trade from '@/pages/Trade'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {path: '/', component: Passport},
    {path: '/home', component: Home},
    {path: '/mine', component: Mine},
    {path: '/success', component: Success},

    {path: '/order', component: SalOrderModel},
    {path: '/orders', component: Orders},

    {path: '/bind', component: Bind},
    {path: '/passport', component: Passport},
    {path: '/qrcode', component: Qrcode},

    {path: '/wallet', component: Wallet},
    {path: '/wishlist', component: Wishlist},
    {path: '/verifies', component: Verifies},
    {path: '/trade', component: Trade},
    {path: '/request', component: Request},

    {path: '/inf/article/model', component: InfArticleModel},

    {path: '/cus/user/modify', component: CusUserModify},
    {path: '/sal/order/model', component: SalOrderModel},
    {path: '/sal/product/model', component: SalProductModel},
    {path: '/sal/pledge/model', component: SalPledgeModel},
    {path: '/sal/pledge/models', component: SalPledgeModels},
    {path: '/wei/user/mobile', component: WeiUserMobile},
    {path: '/wei/user/modify', component: WeiUserModify}
  ]
})

const whites = [
  '/passport'
]

router.beforeEach((to, from, next) => {
  if (whites.indexOf(to.path) >= 0 || store.state.permission.token !== '') {
    next()
  } else {
    let path = '/passport?uri=' + to.fullPath
    next({path: path})
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js